
import {
  Button,
  TableCell,
  TextField,
} from '@material-ui/core';
import React from 'react';

const RowProductVirtual = ({product, onEmitCount, deleteComplect}) => {
  const changeCount = (event) => {
    if (event.target.value >= 0) {
      onEmitCount({...product, count: event.target.value})
    } else {
      onEmitCount({...product, count: 0})
    }
  }

  return (
    <>
      <TableCell>{product.id}</TableCell>
      <TableCell>{product.article}</TableCell>
      <TableCell>{product.name}</TableCell>
      <TableCell  >
        <TextField
          size={"small"}
          value={product.count}
          onChange={changeCount}
          style={{ width: '70px' }}
          inputProps={{ min: 1 }}
          type="number"
          InputLabelProps={{
            shrink: true,
          }}
        />
      </TableCell>
      <TableCell>
        <Button
          variant='outlined'
          color='error'
          onClick={() => deleteComplect(product.id)}
        >
          Удалить
        </Button>  
      </TableCell>
    </>
  )
}

export default RowProductVirtual